<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title"><i class="fas fa-bell"></i> {{ title | translate }}
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <ngb-carousel class="mh-370">
      <ng-template ngbSlide *ngFor="let ads of newListAds, let index = index">
        <a (click)="navigateToUrl(ads)">
          <quill-editor class="ql-toolbar.ql-snow"
                        readOnly="true" theme="bubble"
                        [(ngModel)]="ads.description">
          </quill-editor>
        <img [src]="getImageUrl(ads)" alt="Random first slide" class="d-block w-100 container-image"
             *ngIf="isPresentImage(ads)">
        </a>
      </ng-template>
      <br>
    </ngb-carousel>
    <div class="modal-footer">
      <div class="container">
        <div class="row">
          <div class="col-md-8">
            <div *ngIf="viewCheckOption">
              <div class="custom-control custom-checkbox ml-2">
                <input type="checkbox"
                       id="checkbox"
                       class="custom-control-input"
                       (change)="change($event)">
                <label class="custom-control-label"
                       for="checkbox">{{'LABEL.DONT_SHOW_ADS' | translate}}</label>
              </div>
            </div>
          </div>
          <div class="col content-position-end">
            <div class="btn-padding-dlg">
              <button type="button" class="btn btn-outline-success" data-dismiss="alert" aria-label="Close"
                      (click)="accept()">{{ "BUTTON.ACCEPT" | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
